import { Skeleton } from "antd";
import LazyLoadImage from "apps/Common/LazyLoadImage";
import favIconUrl from "assets/Images/SkeltonCardLogo.svg";

const ChatMessageListSkeleton = ({ loading, children }: { loading: boolean, children: React.ReactNode }) => {
  return (
    <>
      {loading ? (
        <div className="flex-1 !overflow-auto space-y-4">
          {[...Array(3)].map((_, index) => {
            const isRight = index % 2 === 0; // Çift indeksler sağda, tek indeksler solda olacak
            return (
              <div
                key={index}
                className={`!flex items-start space-x-3 ${isRight ? "justify-end" : "justify-start"}`}
              >
                {!isRight && <Skeleton.Avatar active size={40} shape="circle" />} {/* Soldaysa avatar önce */}

                <div className="p-3 rounded-lg max-w-xs !flex !flex-col gap-2 bg-gray-100">
                  <Skeleton.Input active size="small" style={{ width: 100 }} />
                  <Skeleton.Input active size="small" style={{ width: 150 }} />
                  <div className="!bg-[#f0f0f0] !w-full !h-[200px] !flex justify-center items-center ">
                        <div className="!w-[70px] !h-[70px] !rounded-full !bg-[#FFEDCC] !flex items-center justify-center" >

                          <div className="!w-[40px] !h-[40px] loader" ></div>
                        </div>
                     
                      </div>
                  <Skeleton.Input active size="small" style={{ width: 80 }} />
                </div>

                {isRight && <Skeleton.Avatar active size={40} shape="circle" />} {/* Sağdaysa avatar sonra */}
              </div>
            );
          })}
        </div>
      ) : (
        children
      )}
    </>
  );
};

export default ChatMessageListSkeleton;
